export function imgSrc(url) {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  const path = url.startsWith("/") ? url : `/api/files/${url}`;
  return `${process.env.REACT_APP_BACKEND_URL}${path}`;
}
